import FileHelper from './FileHelper';

export default class Archive extends FileHelper{

}
